import React from 'react';
import { LegalFooter as LegalFooterUi, LegalFooterLoadingPlaceholder } from '@cp-shared-19/frontend-ui';
import { formatCpDate } from '@cp-shared-19/common-utilities';
import { LegalFooterLinkCMS } from '@cp-shared-19/apis';
import { withLoadingAndNoConnectionHandler } from 'components/integration-wrapper';
import { useLegalFooter } from './useLegalFooter';

const LegalFooterWithHandlers = withLoadingAndNoConnectionHandler(LegalFooterUi);

type WindowWithCookieControl = Window & { CookieControl?: { open?: () => void } };

const openCookieSettings = (): void => {
    (window as WindowWithCookieControl).CookieControl?.open?.();
};

export const LegalFooter: React.FC = () => {
    const { cmsContent: legalFooter, isLoading, loadingError } = useLegalFooter();
    const currentYear = formatCpDate().toMoment().year();

    const handleOnCookieSettingsClick = (event: React.MouseEvent) => {
        event.preventDefault();
        openCookieSettings();
    };

    const mappedLinks = !legalFooter?.links
        ? []
        : (legalFooter?.links as Array<LegalFooterLinkCMS & { type: string }>)?.map(
              (link): LegalFooterLinkCMS => {
                  if (link?.type !== 'cookie-settings') return link;

                  const { text, url } = link;

                  return { text, url, onClickHandler: handleOnCookieSettingsClick };
              },
          );

    return (
        <LegalFooterWithHandlers
            copyrightText={legalFooter?.copyrightText && `${legalFooter?.copyrightText} ${currentYear}`}
            legalText={legalFooter?.legalText}
            isLoading={isLoading}
            links={mappedLinks}
            hasError={!!loadingError}
            loadingPlaceholder={<LegalFooterLoadingPlaceholder />}
        />
    );
};
